import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
//axios
import useAxiosHook from "src/webapp/hooks/comn/axios.hook";
//cookie
import { getCookie, removeCookie } from "src/webapp/config/cookie";
//store
import usePartnerStore from "src/webapp/stores/partner.store";

const useAuthHook = () => {
    const navigator = useNavigate();//navigator
    const { axiosPostHandler } = useAxiosHook();//axios
    const { partner, setPartner, setState } = usePartnerStore();//store
    
    const isLock = useRef(false);//더블클릭방지
    /* =============== 로그아웃 =============== */
    const onLogoutHandler = async() => {
        if(isLock.current) { return}
        
        isLock.current = true;
        const DATA = { PARTNER_CD:partner.COMN_CD, REFRESH_TOKEN:getCookie("NIDRP") };
        const result = await axiosPostHandler(`partnerTokenDeleteForPartner.do`, DATA);
        isLock.current = false;
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            removeCookie("NIDAP");
            removeCookie("NIDRP");

            setState(false);
            setPartner({});

            navigator("/", { replace: true });
        }
    };
    /* =============== 로그아웃 =============== */

    return { onLogoutHandler//로그아웃
    };
}

export default useAuthHook;